export default __webpack_public_path__ + "static/media/watch.c78c18be.png";